import { MobileNavbar } from "@/app/layouts/mobile-navbar.tsx";
import { VosReactie } from "@/features/medewerkers-op-station";

import { Container } from "@/shared/components";
import { useSearchParams } from "react-router";

export function VosRegistratie() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("uniqueToken");

    return (
        <div className="flex min-h-full flex-1 flex-col" style={{ "--header-height": "64px" } as React.CSSProperties}>
            <MobileNavbar />
            <Container className="py-2" fluid>
                {token && <VosReactie token={token} />}
            </Container>
        </div>
    );
}
